<template>
    <div style="margin: 0 2rem 0 0;">
      <div
        v-if="organisationalUnitName"
        style="margin: 0.5rem 0 1rem 0;"
      >
        <b-tag
          type="is-primary"
          :closable="isClosable"
          @close="resetSelectedOrga"
        >
          <b-tooltip
            :active="showTooltip(organisationalUnitName)"
            :label="organisationalUnitName"
            type="is-basalt"
            position="is-top"
            size="is-small"
            :square="true"
            multilined
          >
            {{ labelFormatter(organisationalUnitName) }}
          </b-tooltip>
        </b-tag>
      </div>
      <div
        v-else
        style="margin: 0.5rem 0 1rem 0;"
      >
        <b-tag type="is-primary">Lade...</b-tag>
      </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import PublicViewHelper from '@/components/mixins/PublicViewHelper'
import TooltipHelper from '@/components/mixins/TooltipHelper'

export default {
  name: 'fob-public-select-tag',
  mixins: [PublicViewHelper, TooltipHelper],
  data () {
    return {
      maxLengthOfTags: 46
    }
  },
  props: {
    view: { default: 'ou' }
  },
  computed: {
    ...mapGetters({
      publicViewSelected: 'publicView/getSelected'
    }),
    isClosable () {
      if (this.organisationalUnitName !== 'Universität Leipzig') {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions({
      resetSelectedTreeItem: 'tree/reset',
      selectBranch: 'tree/selectBranch',
      loadAsyncStaff: 'publicView/loadAsyncStaff'
    }),
    resetSelectedOrga () {
      this.resetSelectedTreeItem()
      if (this.view === 'ou') {
        this.setRoute('ou', 1)
      } else if (this.view === 'person') {
        this.$emit('reset-selected-orga')
      }
    },
    selectOrganisationalUnit (ou) {
      // this.selectBranch({ id: ou.id, name: ou.name })
      // TODO: set 'ou' or 'person' dynamically
      this.setRoute('ou', ou.id)
    },
    setRoute (type, id) {
      let to = {
        name: 'public',
        params: {
          type,
          id,
          resourceType: this.activeResourceType
        }
      }
      this.$router.replace(to)
    }
  }
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/public/PublicSelectTag.vue